module.exports = __webpack_public_path__ + "media/images/icons/energie-icons-plus-961fae9f9bd8a55674353b6ebb79c835.svg";